<template>
  <div class="pay_list">
    <dl>
      <dt>订单编号：{{businessId}}</dt>
      <dd>
        <img v-if="params.faceUrl" :src="params.faceUrl" class="list_img" />
        <img v-if="!params.faceUrl || params.faceUrl==''" src="@/assets/images/live_img.jpg" class="list_img" />
        <h3>{{params.name}}</h3>
        <p class="price_a">金额 ¥<span>{{params.cost}}</span>元</p>
      </dd>
    </dl>
  </div>
</template>
<script>
  export default {
    name: 'coursePayInfo',
    props: ['businessID', 'productID'],
    data () {
      return {
        productId: this.productID,
        businessId: this.businessID,
        params: {},
        result: {}
      }
    },
    created () {
      this.getCourse(this.productId)
    },
    methods: {
      getCourse (id) {
        this.$api.get(this.$global.enrollApiPath, '/signupinfo/get', {id: id}, r => {
          if (r.data) {
            this.params = r.data
            this.getBuyRecord(this.businessId)
          }
        })
      },
      getBuyRecord (businessId) {
          this.result = {
            money: this.params.cost,
            subject: this.params.name
          }
          this.$emit('success', this.result)
      }
    }
  }
</script>
<style scoped>
  .box pay_bg { padding-top: 0; }
</style>



// WEBPACK FOOTER //
// src/page/modules/enroll/pay_info.vue